// extracted by css-extract-rspack-plugin
export default {"textInput":"h8NOv","modalContent":"vvx_0","modalBody":"Rik0J","singlePickerView":"aAqLX","loadingSkeleton":"EUv7i"};